import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';

export default function ConsultAbout() {
  const navigate = useNavigate();

  return (
    <div className="pi">
      <Navbar module="consult" />

      <div className="sh">
        <span className="ey ey-r">✦ Trusted Matrimonial Host ✦</span>
        <h1>About Host <em>Laxmikant Timilsina</em></h1>
        <p>
          Providing confidential, traditional, and horoscope-matched matrimonial services rooted in Tansen-09, Palpa and serving families across Nepal.
        </p>
      </div>

      <div className="sec" style={{ maxWidth: '920px' }}>
        {/* Host Profile Banner */}
        <div className="card-glass" style={{ marginBottom: '2.5rem', textAlign: 'left' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', alignItems: 'center' }}>
            <div>
              <div className="badge-verified" style={{ marginBottom: '0.8rem' }}>
                ✓ Official Matrimonial Host
              </div>
              <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.2rem', fontWeight: 700, color: 'var(--deep)', marginBottom: '0.4rem' }}>
                Laxmikant Timilsina
              </h2>
              <div style={{ fontSize: '0.9rem', color: 'var(--gold-d)', fontWeight: 600, marginBottom: '1rem' }}>
                📍 Resident of Tansen-09, Palpa, Nepal
              </div>
              <p style={{ fontSize: '0.9rem', color: 'var(--mid)', lineHeight: 1.7, marginBottom: '1.2rem' }}>
                For over a decade, Laxmikant Timilsina has guided hundreds of families through traditional Nepalese matchmaking. By combining cultural values, Gotra compatibility, and horoscope (Kundali) evaluation with modern privacy protection, we ensure that finding your life partner is a safe, dignified, and joyous journey.
              </p>
              <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
                <a href="tel:9857074103" className="btn btn-rose btn-sm">
                  📞 Call Laxmikant: 9857074103
                </a>
                <button className="btn btn-gold btn-sm" onClick={() => navigate('/consultation/payment')}>
                  📲 QR Registration (NPR 1,500)
                </button>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, #1E1716, #3B121A)',
              borderRadius: '20px',
              padding: '2rem',
              color: '#F7D070',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🙏</div>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', color: '#fff', marginBottom: '0.6rem' }}>
                Our Core Pillars
              </h3>
              <ul style={{ listStyle: 'none', textAlign: 'left', fontSize: '0.84rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.85)' }}>
                <li>✓ 100% Confidential Profile Handling</li>
                <li>✓ Verified Identity Check by Host</li>
                <li>✓ Traditional Kundali & Gotra Match</li>
                <li>✓ Direct Family Facilitation</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Office & Operations Card */}
        <div className="card card-lg" style={{ textAlign: 'left' }}>
          <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, marginBottom: '1rem' }}>
            Matrimony & Partnered Event Services
          </h3>
          <p style={{ fontSize: '0.9rem', color: 'var(--mid)', lineHeight: 1.7, marginBottom: '1.2rem' }}>
            In addition to matrimonial consultation, Laxmikant Timilsina partners with <strong>Krishna Khanal</strong> (also resident of Tansen-09, Palpa) to operate <strong>Sabitri Catering and Tent House</strong> from their main office at <strong>Butwal-10, Yogikuti Chowk</strong>.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '1rem',
            background: 'var(--cream)',
            padding: '1.2rem',
            borderRadius: '16px'
          }}>
            <div>
              <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: 'var(--muted)', fontWeight: 700 }}>
                HOST RESIDENCE
              </div>
              <div style={{ fontSize: '0.9rem', fontWeight: 700, color: 'var(--deep)', marginTop: '0.2rem' }}>
                Tansen-09, Palpa, Nepal
              </div>
              <div style={{ fontSize: '0.8rem', color: 'var(--mid)' }}>Contact: 9857074103</div>
            </div>

            <div>
              <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: 'var(--muted)', fontWeight: 700 }}>
                MAIN OFFICE LOCATION
              </div>
              <div style={{ fontSize: '0.9rem', fontWeight: 700, color: 'var(--deep)', marginTop: '0.2rem' }}>
                Butwal-10, Yogikuti Chowk
              </div>
              <div style={{ fontSize: '0.8rem', color: 'var(--mid)' }}>Sabitri Catering & Tent House</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
